import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class MenuService {
    async createNewUser(data) {
        const response = await axios.post(Config.apiBasePath + '/createUser', data, { headers: authHeader() });
        return response.data;
    }
    async getMainMenus() {
        const response = await axios.get(Config.apiBasePath + '/fetchAllMainMenu', { headers: authHeader() });
        return response;
    }
    async getSUbMenusbyMenuId(data) {
        const response = await axios.post(Config.apiBasePath + '/fetchSubMenuByMainMenuId', data, { headers: authHeader() });
        return response;
    }
    async saveRoleMenu(data) {
        const response = await axios.post(Config.apiBasePath + '/saveRoleMenu', data, { headers: authHeader() });
        return response;
    }
    async getMainMenuListByRole(id) {
        const response = await axios.get(Config.apiBasePath + '/fetchMenuByRole?roleId=' + id, { headers: authHeader() });
        return response;
    }
}

export default new MenuService();